import React from 'react';
import { bool, arrayOf, shape, func } from 'prop-types';
import { ProductPod } from '../../../../components/ProductPod/ProductPod';

const PreviousProductsDesktop = (props) => (
  <section
    className="gcc-prvprod cf relative mw9 center"
    style={{ minHeight: '355px' }}
    id="prev viewed product carousel"
  >
    <div
      className="absolute left-0 right-0 center tc pa3 z-3 bg-light-gray br4 near-black b"
      style={{ display: props.isLoading ? 'block' : 'none', top: '50%', width: '200px' }}
    >
      Loading Products...
    </div>
    {!props.isLoading && (
      <div
        role="button"
        tabIndex={0}
        onClick={props.onPrevious}
        className={`pointer f2 absolute left-0 top-0 bottom-0 flex items-center ${
          props.hasPrevious() ? 'black' : 'gray'
        }`}
      >
        <span className="bdc-font bdc-font-arrow-left" />
      </div>
    )}
    <h2 className="f4 f3-ns w-100 tc mv4">Previously Viewed Products</h2>
    <div className={`flex justify-center w-100 ${props.isLoading ? 'o-20' : ''}`}>
      {props.products && props.products.map((product) => <ProductPod key={product.ProductId} product={product} />)}
    </div>
    {!props.isLoading && (
      <div
        role="button"
        tabIndex={0}
        onClick={props.onNext}
        className={`pointer f2 absolute right-0 top-0 bottom-0 flex items-center ${props.hasNext() ? 'black' : 'gray'}`}
      >
        <span className="bdc-font bdc-font-arrow-right" />
      </div>
    )}
  </section>
);

PreviousProductsDesktop.propTypes = {
  isLoading: bool.isRequired,
  products: arrayOf(shape({})).isRequired,
  hasNext: func.isRequired,
  hasPrevious: func.isRequired,
  onPrevious: func.isRequired,
  onNext: func.isRequired,
};

export default PreviousProductsDesktop;
